// extracted by mini-css-extract-plugin
export var attachment = "_oy-a";
export var emailContainer = "_oy-4";
export var emailContentPaddedContainer = "_oy-b";
export var emailHeader = "_oy-6";
export var emailIframe = "_oy-3";
export var emailInfoIcon = "_oy-9";
export var emailShortenedSummary = "_oy-e";
export var infoDropdown = "_oy-0";
export var infoRowBoundedContent = "_oy-d";
export var internal = "_oy-5";
export var merchant = "_oy-8";
export var messageInputContainer = "_oy-h";
export var normal = "_oy-7";
export var replyCard = "_oy-f";
export var subtleButton = "_oy-1";
export var subtleButtonIconContainer = "_oy-2";
export var toggleViewRepliesButton = "_oy-c";
export var wrappingText = "_oy-g";